import { IconTypes } from '@eika/icon';
import { InfoTag } from '@eika/tag';

interface ChildTagProps {
    name: string;
}

export const ChildTag = ({ name }: ChildTagProps) => (
    <InfoTag id="child-tag" icon={IconTypes.UNG_36}>
        {name}
    </InfoTag>
);
